"use client";

import { ChevronDown } from "lucide-react";
import clsx from "clsx";
import type { NavItem } from "./navPanel";

type Props = {
  navItems: NavItem[];
  activeDropdown: number | null;
  setActiveDropdown: React.Dispatch<React.SetStateAction<number | null>>;
  anchorRefs: React.RefObject<(HTMLElement | null)[]>;
};

/**
 * Sólo los disparadores del menú de escritorio. El panel se renderiza aparte,
 * como hijo del header, para no depender de `position: fixed`.
 */
export default function NavMenu({
  navItems,
  activeDropdown,
  setActiveDropdown,
  anchorRefs,
}: Props) {
  return (
    <ul className="flex items-center gap-6 xl:gap-8">
      {navItems.map((item, index) => (
        <li key={item.label}>
          <button
            type="button"
            ref={(el) => {
              anchorRefs.current[index] = el;
            }}
            onClick={() =>
              setActiveDropdown((prev) => (prev === index ? null : index))
            }
            aria-expanded={activeDropdown === index}
            className={clsx(
              "relative flex items-center gap-1.5 py-2 text-base xl:text-lg font-semibold whitespace-nowrap cursor-pointer transition-colors duration-300",
              activeDropdown === index
                ? "text-[var(--blanco)]"
                : "text-[var(--blanco)] hover:text-[var(--acento-nav)]",
            )}
          >
            {item.label}
            <ChevronDown
              size={16}
              className={clsx(
                "transition-transform duration-300",
                activeDropdown === index && "rotate-180",
              )}
            />
            <span
              className={clsx(
                "absolute -bottom-0.5 left-0 h-0.5 bg-[var(--acento-nav)] transition-all duration-300",
                activeDropdown === index ? "w-full" : "w-0",
              )}
            />
          </button>
        </li>
      ))}
    </ul>
  );
}
